
    <div class="column" [innerHTML]="html1"></div>
    <div class="column" [innerHTML]="html2"></div>
